export default __webpack_public_path__ + "static/media/i2talk.b5d463e4.png";